/**
 * Visual tokens for the action-oriented widgets. Keeping them centralised
 * matches the feature-folder convention (see `web/AGENTS.md`).
 */

export const widgetTokens = {
  card: {
    minHeight: 220,
  },
  // Soft muted backgrounds (warm palette).
  header: {
    /**
     * Icon wrapper sized to MATCH the title's line-box height (28px for the
     * subtitle1 font at lineHeight 1.75). Keeping these two vertical
     * rhythms equal means the icon box and the title's first line occupy
     * the same top/bottom edges — no visual drift whether the title is
     * single- or multi-line (round-9 fix).
     */
    iconWrapper: {
      width: 28,
      height: 28,
      borderRadius: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    /**
     * Minimum header row height. Reserve enough space for a two-line title
     * (2 × 28px line height = 56) so a "Timesheets overdue" card with a
     * one-line title reserves the same vertical space as a "Team away this
     * week" card with a wrapped title, keeping content below aligned
     * across the dashboard row (round-7 feedback).
     */
    minHeight: 56,
  },
  emptyState: {
    py: 3,
    textAlign: 'center' as const,
    color: 'text.secondary',
  },
  /**
   * Maximum rows rendered by list-style widgets before collapsing the tail
   * into a "View all (N more)" footer link. Uniform across widgets so cards
   * stay roughly the same height (see round-3 feedback).
   */
  maxRows: 5,
  /**
   * Minimum vertical space for a list row. All list-style widgets should set
   * `minHeight: widgetTokens.listRowMinHeight` on their `ListItem` so
   * rows line up side-by-side even when some widgets carry a secondary line
   * and others don't (see round-5 feedback about Overdue vs Pending vs
   * Team-away widgets lining up). Tuned in round-8 to avoid the list feeling
   * cramped while still leaving room for the two-line "name + date" layout.
   */
  listRowMinHeight: 42,
} as const;
